import { extend } from 'vee-validate';

import { isNonNumericOrSymbol } from '@/core/rules';

extend('non_numeric_or_symbol', isNonNumericOrSymbol);
